import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

// ✅ PPC API URL - Update this for production
export const PPC_API_URL = 'https://ccc4cs.choicegroup.in/api/ppc';

// For local development, use:
// export const PPC_API_URL = 'http://10.0.2.35/Contractors-Dashboard/backend/API';

// PPC Auth Context
export const PPCAuthContext = createContext(null);
export const usePPCAuth = () => useContext(PPCAuthContext);

// PPC Auth Provider - Uses the main app's token
export const PPCAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get user from main app's localStorage
    const storedUser = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    
    if (storedUser && token) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('username');
    window.location.href = '/login';
  };

  return (
    <PPCAuthContext.Provider value={{ user, logout, loading }}>
      {children}
    </PPCAuthContext.Provider>
  );
};

// Axios instance for PPC API calls
export const ppcApi = axios.create({
  baseURL: PPC_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to all PPC API requests
ppcApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 errors
ppcApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default PPCAuthProvider;
